import { render, staticRenderFns } from "./PackagePopup.vue?vue&type=template&id=216012dd&scoped=true&"
import script from "./PackagePopup.vue?vue&type=script&lang=js&"
export * from "./PackagePopup.vue?vue&type=script&lang=js&"
import style0 from "./PackagePopup.vue?vue&type=style&index=0&id=216012dd&lang=scss&scoped=true&"
import style1 from "./PackagePopup.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216012dd",
  null
  
)

export default component.exports